import { createFileRoute } from "@tanstack/react-router";
import { listWorkflows } from "api-client";
import { z } from "zod";

import { BillingProductFeatureGate } from "src/components/BillingProductFeatureGate";
import { loaderHandler } from "src/lib/loaderHandler";
import { CoachWorkflowsPage } from "src/pages/CoachWorkflowsPage";

export const WORKFLOWS_DEFAULT_PAGE_SIZE = 10;

const searchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute("/_auth/_coach/workflows/")({
  component: RouteComponent,
  validateSearch: searchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ deps }) {
    return await loaderHandler(async () => {
      const pageSize = deps.ps || WORKFLOWS_DEFAULT_PAGE_SIZE;
      const response = await listWorkflows({
        query: {
          query: deps.q,
          pageIndex: deps.p,
          pageSize,
        },
      });

      return {
        data: {
          workflows: response.data.data,
          pageSize,
        },
      };
    });
  },
  staticData: {
    getBreadcrumb({ i18n }) {
      return {
        label: i18n.t("sidebar.workflows"),
        href: "/workflows",
      };
    },
  },
});

function RouteComponent() {
  return (
    <BillingProductFeatureGate feature="trainingGroups">
      <CoachWorkflowsPage />
    </BillingProductFeatureGate>
  );
}
